"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const validateTransform = (transformation) => {
    const { fields } = transformation;
    // ensure that fields are not duplicated.
    const uniqueFieldNames = new Set();
    const errors = [];
    fields.forEach(({ name }) => {
        if (uniqueFieldNames.has(name)) {
            errors.push({
                type: 'metadataValidation',
                message: `[field:${name}] is duplicated`,
            });
        }
        else {
            uniqueFieldNames.add(name);
        }
    });
    // ensure all fields specify same number of pages
    // its okay for page numbers to be different for each field
    // but there must be sane number of pages specified for each field
    const uniquePageNumbers = new Set();
    fields.forEach(({ pageNumbers, name }) => {
        (0, common_1.finleyAssert)(pageNumbers, 'pageNumbers is required');
        pageNumbers.forEach((pageNumber) => {
            if (pageNumber === 0) {
                errors.push({
                    type: 'metadataValidation',
                    message: `pageNumber cannot be zero. Found 0 for [field:${name}]`,
                });
            }
        });
        uniquePageNumbers.add(pageNumbers.length);
    });
    if (uniquePageNumbers.size > 1) {
        errors.push({
            type: 'metadataValidation',
            message: `all fields must specify same number of pages`,
        });
    }
    if (errors.length > 0) {
        return {
            isValid: false,
            errors,
        };
    }
    return { isValid: true, data: null };
};
exports.validateTransform = validateTransform;
const performTransform = async ({ dataTapeBuffers, transformation, pdfExtractor, }) => {
    try {
        (0, common_1.finleyAssert)(dataTapeBuffers.length === 1, 'Expected 1 data tape buffer');
        const { fields } = transformation;
        const queries = fields.map(({ question, pageNumbers }) => ({
            question,
            pageNumbers,
        }));
        const srcDataTapeBuffer = dataTapeBuffers[0];
        const pdfResult = await pdfExtractor(srcDataTapeBuffer, queries);
        // create a single row csv array, that has the field names as header
        // and the answers as values.
        const csvArray = [
            fields.reduce((acc, { name }, index) => {
                // find the answer for this question
                const { value, confidence, error, pageNumber } = pdfResult.answers[index];
                return {
                    ...acc,
                    [`${name}#value`]: value,
                    [`${name}#confidence`]: confidence,
                    [`${name}#error`]: error,
                    [`${name}#pageNumber`]: pageNumber,
                };
            }, {}),
        ];
        const outputBuffer = common_1.csvConversion.csvArrayToFinleyBuffer({
            csvArray,
        });
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'pdf2csv: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'pdf2csv',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=pdf2csv.js.map